/** @module csi/resolver */
define([
	"csi/reflection",
	"csi/xml"
], function(reflection, xml) {

	let _cache;

	function initialize(cache) {
		_cache = cache;
	}

	function resolveClass(/*Class?*/rc, /*Node?*/node, /*String?*/url, /*String?*/path, /*Cache?*/cache) {
		// summary: return class at end of optional URL and path given optional source class or node
		cache = cache || _cache;

		if (url) {
			node = this.resolveNode(url, true, cache);
			rc = null;
		}

		if (path) {
			if (rc) {
				rc = rc.getPathClass(path);
			} else if (node) {
				node = cache.getPathNode(node, path, true);
			}
		}

		return rc || reflection.getNodeClass(node);
	}

	function resolveNode(url, bForce, cache) {
		// first try to find in parameter cache if present; if not there, then use resolver cache
		var node = cache && cache.get(url);
		if (!node) {
			node = _cache.getNode(url, bForce);

			// add to parameter cache if found in resolver cache
			if (cache && node) {
				cache.add(node);
			}
		}

		return node;
	}

	function resolveNodeDeferred(url, bForce, cache) {
		// try to find in given cache if present
		var node = cache && cache.get(url);
		if (node) {
			return Promise.resolve(node);
		}

		return _cache.getNodeDeferred(url, bForce).then(function(nodeGot) {
			// add to parameter cache if found in resolver cache
			if (cache && nodeGot) {
				cache.add(nodeGot);
			}

			return nodeGot;
		});
	}

	function resolveParent(/*Node|String*/node, /*Cache?*/cache, /*Boolean*/bRecursive) {
		// summary: find parent of given node/url - if no id is given, then assume composite parent and use parent back-pointer
		if (!node) return null;

		if (typeof node === "string") {
			node = this.resolveNode(node, true, cache);
			if (!node) return null;
		}

		// try to find in secondary cache if passed
		if (cache) {
			var parent = cache.get(node.__Parent__);
			if (parent) return parent;
		}

		// otherwise get from main cache
		return _cache.getNode(node.__Parent__, true, bRecursive ? function(req) {
			req.mixinParameters({
				"Dep.Child.Level": -1,
				"Dep.Child.Attr": xml.ATTR_PARENT
			});
		} : null);
	}

	/**
	 * Iterate up parents until subtyped node is found
	 * @param {Node} node
	 * @param {Cache} [cache]
	 * @return {Node|null}
	 */
	function resolveSubtypedNode(node, cache) {
		while (node && !node.Subtype) {
			node = this.resolveNode(node.__Parent__, false, cache);
		}

		return node;
	}

	function resolveAncestor(/*Node|String*/node, /*String*/typeNode, /*Cache?*/cache) {
		// summary: traverse up parent chain until given node type is found
		if (typeof node === "string") {
			node = this.resolveNode(node, true, cache);
		}

		while (node && (xml.nodeGetType(node) != typeNode)) {
			node = this.resolveParent(node, cache, true);
		}

		return node;
	}

	return {
		get m_cache() {
			return _cache;
		},

		initialize,
		resolveAncestor,
		resolveClass,
		resolveNode,
		resolveNodeDeferred,
		resolveParent,
		resolveSubtypedNode,
	};
});